exports.types = {
  DATE: "DATE",
  UUID: "UUID", //text // validator
  UUIDV4: "UUIDV4", //text //validator
  STRING: "STRING", //text
  BOOLEAN: "BOOLEAN",
  TEXT: "TEXT", //text
  INTEGER: "INTEGER", // number
  FLOAT: "FLOAT", // number
  DOUBLE: "DOUBLE", // number
  TIME: "TIME",
  DATEONLY: "DATEONLY",
  JSON: "JSON",
  JSONB: "JSONB",
  ARRAY: "ARRAY", //never
  ENUM: "ENUM",
};

exports.uiTypes = {
  TEXT: "TEXT",
  NUMBER: "NUMBER",
  TEXT_AREA: "TEXT_AREA",
  TEXT_ARRAY: "TEXT_ARRAY",
  DROPDOWN: "DROPDOWN",
  DROPDOWN_MULTISELECT: "DROPDOWN_MULTISELECT",
  CHECKBOX: "CHECKBOX",
  RADIO: "RADIO",
  DATE_TIME: "DATE_TIME",
  DATE: "DATE",
  TIME: "TIME",
  WYSIWYG_EDITOR: "WYSIWYG_EDITOR",
  IMAGE: "IMAGE",
  MULTI_IMAGE: "MULTI_IMAGE",
  DOCUMENT: "DOCUMENT",
  MULTI_IMAGE_VIDEO: "MULTI_IMAGE_VIDEO",
  FILE: "FILE",
  MULTI_FILE: "MULTI_FILE",
  JSON: "JSON",
  SWITCH: "SWITCH",
  MAP: "MAP",
};

exports.referenceTypes = {
  ONE: "ONE",
  MANY: "MANY",
};
